import { Collapse, Link, Stack, Typography } from '@mui/material';
import { FileField, FileInput, TextInput } from 'react-admin';
import { useState } from 'react';

export const NoteInputs = ({ edition }: { edition?: boolean }) => {
    const [displayMore, setDisplayMore] = useState(false);
    return (
        <>
            <TextInput
                source="text"
                label={edition ? 'Edit note' : 'Add a note'}
                variant="filled"
                size="small"
                multiline
                minRows={3}
                helperText={false}
            />
            {!displayMore && (
                <Stack gap={0.5} direction="row" justifyContent="flex-end">
                    <Link
                        variant="caption"
                        href="#"
                        onClick={e => {
                            setDisplayMore(!displayMore);
                            e.preventDefault();
                        }}
                    >
                        Show options
                    </Link>
                    <Typography variant="caption" color="textSecondary">
                        (attach files)
                    </Typography>
                </Stack>
            )}
            <Collapse in={displayMore}>
                <Stack gap={1} mt={1}>
                    <FileInput source="attachmentsInput" multiple>
                        <FileField source="src" title="title" />
                    </FileInput>
                </Stack>
            </Collapse>
        </>
    );
};
